import { SmartLoaderService } from './core/services/smart-loader.service';
import { SmartModalService, ModalSize } from './core/services/smart-modal.service';
import { Component, OnInit, ViewContainerRef, ElementRef, Renderer2, Inject } from '@angular/core';
import { Title, DOCUMENT } from '@angular/platform-browser';

import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

import { Observable } from 'rxjs/';

import { AuthService } from './core/services/auth.service';
import { SessionService } from './core/services/session.service';
import { ModalService } from './core/services/modal.service';
import { AlertService } from './core/services/alert.service';
import { ConfigService } from './core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import { UtilService } from 'app/core/services/util.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { MiddlemanService } from 'app/core/services/middleman.service';
import { PermissionsService } from './core/services/permissions.service';
import { LoginPromptComponent } from './core/components/login-prompt/login-prompt.component';
import { OktaService } from './core/services/okta.service';

declare var jQuery: any;
@Component({
    selector: 'itpx-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent extends RxComponent implements OnInit {
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };
    private loading: Observable<any>;
    private saharaVersionRequestPending: boolean = false;
    private showAlertsRequestPending: boolean = false;
    private initialStateLoaded: boolean = false;

    constructor(
        private router: Router,
        private titleService: Title,
        private viewContainerRef: ViewContainerRef,
        private configService: ConfigService,
        private authService: AuthService,
        private sessionService: SessionService,
        private modal: ModalService,
        private alertService: AlertService,
        private smartModalService: SmartModalService,
        private loadingService: SmartLoaderService,
        private utilService: UtilService,
        private requestService: RequestService,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private middlemanService: MiddlemanService,
        private permissionsService: PermissionsService,
        private oktaService: OktaService,
        @Inject(DOCUMENT) private document: Document
    ) {
        super();
    }
    onActivate(event) {
        window.scroll(0, 0);
    }
    async ngOnInit() {
        this.utilService.renderer = this.renderer;
        this.utilService.elementRef = this.elementRef;
        this.loading = Observable.combineLatest(
            this.loadingService.loading().delay(10),
            this.smartModalService.isOpen(),
            (loading, isOpen) => loading && !isOpen
        ).map(loading => ({ loading: loading }))
            .do(_ => {
                jQuery(':button').blur();
            });

        let title = 'my.Leapest';
        this.titleService.setTitle(
            (this.configService.get('envName') === 'prod' || this.configService.get('envName') ==='prod-euwest1')
                ? title
                : '[' + this.configService.get('envName') + '] ' + title
        );

        this.modal.setViewContainerRef(this.viewContainerRef);
        this.authService.listenForSessionChange().subscribe();

        this.listenForRouteChanges();
    }

    listenForRouteChanges() {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.checkForLatestVersion();
            }
        });
    }

    private checkForLatestVersion() {
        if (this.sessionService.getSaharaVersion() || !this.saharaVersionRequestPending) {
            this.saharaVersionRequestPending = true;
            this.getSaharaVersion().subscribe(
                body => {
                    let latestVersion = body.data.version;
                    let currentVersion = this.sessionService.getSaharaVersion();
                    if (latestVersion !== currentVersion) {
                        this.utilService.reload();
                    }
                },
                error => { },
                () => (this.saharaVersionRequestPending = false)
            );
        }
    }

    private getSaharaVersion(): Observable<any> {
        let url =
            this.configService.get('server').sahara +
            this.configService.get('endpoints').sahara.other.version.api;
        return this.requestService.get(url, null, null, true);
    }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts